export default __webpack_public_path__ + "static/media/logo2.8d8a9651.svg";